import { dialog } from "../../../../nq-component";
import React from "react";

function DialogSuccess({ message, onBack = true }) {
  const onConfirm = () => {
    dialog.close();
    if (onBack) {
      window.history.back();
    }
  };
  return (
    <>
      <div className="p-4">
        <div className="d-flex align-items-center gap-3">
          <div className="align-self-start">
            <i
              className="bi bi-check-circle fs-2 px-2 py-1 rounded"
              style={{ backgroundColor: "#F5F5F5", color: "#D18237" }}
            ></i>
          </div>
          <div className="d-flex flex-column container-fluid">
            <h5 className="fw-bold mt-2" style={{ color: "#D18237" }}>
              Success
            </h5>
            <p>{message}!</p>
          </div>
        </div>
      </div>
      <div className="text-center mb-3">
        <>
          <>
            <button
              className="btn text-white ms-2"
              style={{ backgroundColor: "#D18237" }}
              onClick={onConfirm}
            >
              Confirm
            </button>
          </>
        </>
      </div>
    </>
  );
}

export default DialogSuccess;
